// extracted by css-extract-rspack-plugin
export default {"container":"vCyTJ2zLEU4OW29N","title":"HTnWiq4uIBeKHTjh","field":"IxcUVh9U0oMUJjVo","textarea":"ADSBqUAVqsDIiyBa"};